import React from "react"
import { cn } from "../../lib/utils"

const buttonVariants = (variant = "default", size = "default", className = "") => {
  const baseClasses = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
  
  const variantClasses = {
    default: "bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800",
    destructive: "bg-red-600 text-white hover:bg-red-700 active:bg-red-800",
    outline: "border border-gray-300 bg-white hover:bg-gray-50 active:bg-blue-50 active:border-blue-300 active:text-blue-700",
    secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300 active:bg-gray-400",
    ghost: "hover:bg-gray-100 active:bg-gray-200",
    link: "text-blue-600 underline-offset-4 hover:underline active:text-blue-800"
  }
  
  const sizeClasses = {
    default: "h-9 px-4 py-2",
    sm: "h-8 px-3 py-1.5",
    lg: "h-10 px-6 py-2.5",
    icon: "h-9 w-9"
  }
  
  return cn(
    baseClasses,
    variantClasses[variant] || variantClasses.default,
    sizeClasses[size] || sizeClasses.default,
    className
  )
}

function Button({ 
  className, 
  variant, 
  size, 
  children, 
  ...props 
}) {
  return (
    <button
      className={buttonVariants(variant, size, className)}
      {...props}
    >
      {children}
    </button>
  )
}

export { Button, buttonVariants }
